import {FavouriteType} from "../types/favourite.type";

export class UserFavourites {
  choose: FavouriteType[];
  discover: FavouriteType[];
  join: FavouriteType[];

  constructor(that?: UserFavourites) {
    if (that) {
      this.choose = that.choose || this.choose;
      this.discover = that.discover || this.discover;
      this.join = that.join || this.join;
    }
  }
}



// WEBPACK FOOTER //
// C:/Development/Private Projects/random-ride/RandomRide/src/app/models/userFavourites.model.ts